import { manageRecordAPI } from "../Modules/Records/RecordAPI";
import { getAuthData } from "./AuthUtils";
import { toast } from "sonner";
import { getConnectionDetailAPI } from "../Modules/Connections/ConnectionAPI";
import { openRecordEntryModal } from "./RecordEntryModal";
import { isIOSDevice } from "./Utilities";

export const createContactLog = async (connectionData, actionType, connID = null, onRecordAdded = null) => {
  try {
    const contactName = connectionData?.name || connectionData?.contName || 'contact';
    const connRecID = connID || connectionData?.connID || 0;

    let recordType, recordNotes;

    if (actionType === 'dialed') {
      recordType = 'Call_Log';
      recordNotes = 'Dialed Call.';
    } else if (actionType === 'message') {
      recordType = 'Message_Log';
      recordNotes = 'Sent Message.';
    } else {
      recordType = actionType;
      recordNotes = `${actionType}: ${contactName}`;
    }

    const authData = getAuthData();

    const recordData = {
      connID: connRecID,
      pocUserID: authData?.UserID || 0,
      recType: recordType,
      recNotes: recordNotes,
      recThreadIDs: '',
      recContractIDs: '',
      recSecConnIDs: '',
      recLat: '',
      recLon: '',
      recDT: new Date(),
      currStageID: 1,
      reason: ''
    };

    await manageRecordAPI(recordData, null, 'ADD', 0);
    toast.success(`Record logged for ${contactName}`);

    if (connRecID && (actionType === 'dialed' || actionType === 'message')) {
      try {
        const connectionDetail = await getConnectionDetailAPI(connRecID, '');
        const records = connectionDetail?.records || [];

        const expectedText = actionType === 'dialed' ? 'Dialed Call.' : 'Sent Message.';
        const filteredRecords = records.filter(record =>
          record?.Typ === (actionType === 'dialed' ? "Call" : "Message") && record.Txt === expectedText
        );

        if (filteredRecords.length > 0) {
          filteredRecords.sort((a, b) => new Date(b.DT) - new Date(a.DT));
          const latestRecord = filteredRecords[0];

          const recordForEdit = {
            recordID: latestRecord.RID,
            connID: connRecID,
            recordType: latestRecord?.Typ,
            notes: latestRecord.Txt,
            recordDate: latestRecord.DT,
            pocUserID: latestRecord.UID,
            threadIDs: latestRecord.TIDs ? latestRecord.TIDs.split(',').filter(Boolean) : [],
            contractIDs: latestRecord.ContractIDs ? latestRecord.ContractIDs.split(',').filter(Boolean) : [],
            secConnIDs: latestRecord.SecConnIDs ? latestRecord.SecConnIDs.split(',').filter(Boolean) : '',
            isEditMode: true,
            connectionLocked: true
          };

          openRecordEntryModal(recordForEdit);
        }
      } catch (error) {
        console.error('Error fetching latest record for edit mode:', error);
      }
    }

    if (onRecordAdded) {
      onRecordAdded();
    }
  } catch (error) {
    console.error('Error creating contact log:', error);
    toast.error('Failed to log record');
  }
};

export const createPhoneLink = (countryCode, mobile) => {
  const cleanedPhone = mobile?.replace(/\D/g, "");
  return `tel:+${countryCode}${cleanedPhone}`;
};

export const createWhatsAppLink = (countryCode, mobile, message = "") => {
  const cleanedPhone = mobile?.replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(message);

  return `https://api.whatsapp.com/send/?phone=${countryCode}${cleanedPhone}&text=${encodedMessage}&type=phone_number&app_absent=0`;
};


export const handlePhoneClickAction = async (connectionData, isDesktop, onRecordAdded = null, connID = null) => {
  const phone = connectionData?.mobile || connectionData?.Mobile;
  const cleanedPhone = phone?.replace(/\D/g, "");

  if (isDesktop) {
    try {
      await navigator.clipboard.writeText(cleanedPhone);
      toast.success(`Mobile (${cleanedPhone}) copied to clipboard!`);
    } catch (err) {
      console.error('Failed to copy: ', err);
      toast.error('Failed to copy to clipboard');
    }
  } else {
    window.open(createPhoneLink(connectionData?.cc || connectionData?.CC, phone), "_self");
    await createContactLog(connectionData, 'dialed', connID, onRecordAdded);
  }
};

export const handleWhatsAppClickAction = async (connectionData, onRecordAdded = null, connID = null, message) => {
  const phone = connectionData?.mobile;

  const whatsappLink = createWhatsAppLink(connectionData?.cc, phone, message);

  window.open(whatsappLink, "_blank");

  await createContactLog(connectionData, 'message', connID, onRecordAdded);
};
